import React from "react";
import { Layout, Button, Card, Form, Input, Select } from "element-react";
import { useHistory } from "react-router-dom";
import WizardLeftMenu from "./wizardLeftMenu";
import { S3Image } from "../../components/S3Image";
import companyImg from '../../assets/imgs/my-company-default.png';
import aboutUsImg from '../../assets/imgs/about-us-default.png';
import NoPicture from '../../assets/imgs/no-picture.png';


export default function WizardNgStep2({
  handleFinish, handlePrevStep, step, formInputs, setFormInputs, t, form0, rules0, type, yearOptions, revenue, editCompanyImage
}) {

  const themeConfig = {
    photoImg: { maxWidth: "650px", maxHeight: "335px", minHeight: "320px" }
  }

  return (
    <Layout.Row>
      <WizardLeftMenu step={step} />
      <Layout.Col xs="23" sm="23" md="20" lg="20">
        <Card className='box-card'>
          <div className='create-store-title'>
            <h1>4. Pictures</h1>
          </div>
          <Layout.Row>
            <Layout.Col xs="24" sm="24" md="24" lg="24">
              <p>Please upload the pictures for your Microsite cover page. You will need to upload a primary image and a secondary image.</p>
            </Layout.Col>
          </Layout.Row>
          <Layout.Row>
            <Layout.Col>
              <div className='help-box-2'>
                <p><b>Tips and suggestions:</b></p>
                <p>
                  You can use your logo, or a picture of your building, team, production line/machines, or any picture that reflect your Company branding.<br></br>
                  Use good quality pictures, they are the face of your company at Bainub!<br></br>
                  You will be able to change them later, as many times as you want.
                </p>
              </div>
            </Layout.Col>
          </Layout.Row>
          <Layout.Row>
            <Layout.Col>
               <hr></hr>
              <p><b>Cover Picture:</b><span className="required-mark">*</span>This picture will be the cover and banner of your Microsite. Use the most representative picture of your Company. You can also use your logo.</p>
            </Layout.Col>
          </Layout.Row>
          <Layout.Row>
            <Layout.Col xs="24" sm="24" md="24" lg="24">
              <div className="card-container">
                {
                  formInputs.cover_picture
                    ?
                    <S3Image
                      imgKey={formInputs.cover_picture.key}
                      theme={themeConfig}
                      level="public"
                    />
                    :
                    <img alt='img' src={NoPicture} style={{ maxWidth: "650px", maxHeight: "335px", minHeight: "235px" }} />
                }

                <div className="company-title-img-btn2">
                  <div className="text-center">
                    <Button type="primary" onClick={() => editCompanyImage('cover_picture')}>
                      {t('my-store.page.button-change-img')}
                    </Button>
                  </div>
                </div>

              </div>

            </Layout.Col>
          </Layout.Row>
          <hr></hr>
          <p><b>About Us Picture:</b><span className="required-mark">*</span> Upload a picture that shows something about your Company: your production lines, your team, a representative product.</p>

          <Layout.Row>
            <Layout.Col xs="24" sm="24" md="24" lg="24">
              <div class="special-container">
                {
                  formInputs.company_logo
                    ?
                    <S3Image
                      className="special-container__image"
                      imgKey={formInputs.company_logo.key}
                      theme={{
                        photoImg: { maxWidth: "40vw" }
                      }}
                      level="public"
                    />
                    :
                    <img alt='img' src={NoPicture} style={{ maxWidth: "650px", maxHeight: "335px", minHeight: "235px" }} />
                }


                <div className="company-title-img-btn2">
                  <div className="text-center">
                    <Button type="primary" onClick={() => editCompanyImage('company_logo')}>
                      {t('my-store.page.button-change-img')}
                    </Button>
                  </div>
                </div>


              </div>
            </Layout.Col>
          </Layout.Row>
          <hr></hr>
          <Layout.Row>
                        <Layout.Col className='mt-2'>
                          <Button type="secondary" onClick={handlePrevStep}>
                            Go back
                          </Button>
                          <Button type="primary" onClick={handleFinish}>
                            {'Finish'}
                          </Button>
                          <p>You will be able to preview and edit your company before publishing</p>
                        </Layout.Col>
                      </Layout.Row>
                      <Layout.Row>
          </Layout.Row>
        </Card>
      </Layout.Col>


    </Layout.Row>
  );
}